import List from "list.js";

var fuzzyList = 'searchBox',
fuzzyOptions = {
	searchClass: "fuzzy-searchBox",
	valueNames: ['nodeTitle', 'subTitle'],
	location: 0,
	distance: 10,
	threshold: 0.4,
	multiSearch: false
};

document.addEventListener("fuzzyListLoaded", function (e) {
	var fuzzySearch = new List('searchBox', fuzzyOptions);

	fuzzySearch.on('searchStart', function (event) {
		document.getElementById('searchList').classList.remove('hidden');
	});
});